import { faFileEdit, faInfoCircle, faListCheck, faListNumeric, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Autocomplete, AutocompleteItem, Button } from '@heroui/react';
import React, { useEffect, useRef, useState } from 'react';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { funCheckNumber } from '../../Utility/utility';
import { usePost, usePostMutateWithSuccess } from '../../api/reactQueryCustomHooks';
import { apiRoute, ENUM_CURRENCY_SETTING_VAL, funValidateNoInput } from '../../constants/enum';
import { toast } from 'react-toastify';

const DynamicTable = ({ currency, RowsField, tabId, cRate, columns, rows = [], deleteRows = [], onChange, onDelete, onLotAllotChange, selLotAllotRow }) => {
  //const [rows, setRows] = useState(initialRows);
  const inputRefs = useRef({});

  const [selColumn, setSelColumn] = useState([])

  useEffect(() => {
    if (selColumn && selColumn.length > 0) {
      if (tabId != "mfgDetail") {
        if (currency == ENUM_CURRENCY_SETTING_VAL.Dollar) {
          const filterCol = columns.filter((ele) => ![RowsField.valueRs, RowsField.rateRs].includes(ele.name))
          setSelColumn(filterCol)
        }
        else if (currency == ENUM_CURRENCY_SETTING_VAL.RS) {
          const filterCol = columns.filter((ele) => ![RowsField.valueD, RowsField.convRate, RowsField.rateD].includes(ele.name))
          setSelColumn(filterCol)
        }
      }
    }
    else
      setSelColumn(columns)
  }, [currency, columns])

  const handleChange = (rowIndex, field, value) => {
    const updated = [...rows];
    updated[rowIndex][field] = value;
    //  console.log(field)
    let tempVal = 0
    if (tabId == "processDetail") {
      const t_weight = field == RowsField.weight ? value : updated[rowIndex][RowsField.weight]
      const t_lossWeight = field == RowsField.lossWeight ? value : updated[rowIndex][RowsField.lossWeight]
      tempVal = parseFloat(t_lossWeight) * 100 / parseFloat(t_weight)
      const val = funCheckNumber(tempVal).toFixed(2)
      updated[rowIndex][RowsField.lossPer] = val;
    }
    const calField = [RowsField.weight, RowsField.rateD, RowsField.rateRs, RowsField.roughCts, RowsField.demandCts,
    RowsField.polishCts, RowsField.polishPcs, RowsField.rateOn]
    if (calField.includes(field)) {// == "weight" || field == "rateD" || field == "rateRs") {

      let t_weight = field == RowsField.weight ? value : updated[rowIndex][RowsField.weight] || 0
      const t_rate = field == RowsField.rateRs ? value : updated[rowIndex][RowsField.rateRs] || 0
      const t_rated = field == RowsField.rateD ? value : updated[rowIndex][RowsField.rateD] || 0


      if (tabId == "mfgDetail") {
        const t_roughCts = field == RowsField.roughCts ? value : updated[rowIndex][RowsField.roughCts] || 0
        const t_demandCts = field == RowsField.demandCts ? value : updated[rowIndex][RowsField.demandCts] || 0
        const t_polishCts = field == RowsField.polishCts ? value : updated[rowIndex][RowsField.polishCts] || 0
        const t_polishPcs = field == RowsField.polishPcs ? value : updated[rowIndex][RowsField.polishPcs] || 0
        const t_rateOn = field == RowsField.rateOn ? value : updated[rowIndex][RowsField.rateOn] || ""
        t_weight = t_rateOn == 'O' ? t_polishCts : t_rateOn == 'R' ? t_roughCts : t_rateOn == 'D' ? t_demandCts : t_rateOn == 'P' ? t_polishPcs : 0;

      }
      tempVal = parseFloat(t_weight) * parseFloat(t_rate)
      const val = funCheckNumber(tempVal).toFixed(2)

      tempVal = parseFloat(t_weight) * parseFloat(t_rated)
      let valD = funCheckNumber(tempVal).toFixed(2)


      if (t_rated <= 0) {
        tempVal = parseFloat(t_weight) * (parseFloat(t_rate) / parseFloat(cRate || 0)).toFixed(2)
        valD = funCheckNumber(tempVal).toFixed(2)
      }

      updated[rowIndex][RowsField.valueD] = valD;
      updated[rowIndex][RowsField.valueRs] = val;
    }

    onChange(updated)

  };

  const handleBlur = (rowIndex, field, value) => {
    const isValid = funValidateNoInput(value);
    if (isValid) {
      const formatted = funCheckNumber(parseFloat(value || 0)).toFixed(2);
      const updated = [...rows];
      updated[rowIndex][field] = parseFloat(formatted);
      onChange(updated)
    }
    if (field == RowsField.lotNo) {
      funChkLotNo({
        data: {
          lotno: value
        },
        onSuccess: (data) => {
          const updated = [...rows];
          const dupRow = rows.filter(ele => ele.lotNo == value && ele.id != updated[rowIndex]["id"])
          if (dupRow && dupRow.length > 0) {
            updated[rowIndex][field] = "";
            //setFormData({ ...formData, [formField.roughNo]: "" })
            if (!toast.isActive('toats_chkLotno')) {
              toast.error("Duplicate Lot No not Allow", {
                "position": "top-center",
                "className": "toast-error",
                toastId: "toats_chkLotno",
              })
            }
            onChange(updated)
          }
          if (data && data.length > 0) {
            if (data[0].count > 0) {
              updated[rowIndex][field] = "";
              //setFormData({ ...formData, [formField.roughNo]: "" })
              if (!toast.isActive('toats_chkLotno')) {
                toast.error("Duplicate Lot No not Allow", {
                  "position": "top-center",
                  "className": "toast-error",
                  toastId: "toats_chkLotno",
                })
              }
              onChange(updated)
            }

          }

        }
      })
    }

  }

  useEffect(() => {
    if (tabId == "Merge")
      onLotAllotChange({})

  }, [])

  const { mutate: funChkLotNo } = usePostMutateWithSuccess({
    url: apiRoute.roughAllotmentEntry.checkLotNo,
    queryKey: "checkLotNo",
  })

  const handleDateChange = (rowIndex, field, newValue) => {
    const updated = [...rows];
    updated[rowIndex][field] = newValue != '' && newValue != 'Invalid Date' ?
      dayjs(newValue).format("YYYY-MM-DD") : null;
    onChange(updated)
  }

  // const handleAutoCompleteChange = (rowIndex, field, value) => {
  //   const updated = [...rows];
  //   updated[rowIndex][field] = value;
  //   onChange(updated)
  // }

  const addRow = () => {
    const newRow = {};
    columns.forEach(col => {
      newRow[col.name] = col.type == "date" ? null : col.type == "number" ? 0 : '';
    });
    const newId = Date.now();
    newRow.id = newId
    newRow.detailId = 0 // or use uuid
    onChange([...rows, newRow]);
    // setRows([...rows, newRow]);

    setTimeout(() => {
      const firstAccessor = columns[0]?.name;
      inputRefs.current[`${newId}-${firstAccessor}`]?.focus();
    }, 50); // allow render to complete

  };

  const removeRow = (index) => {
    const updated = [...rows];
    const deletedRow = updated.splice(index, 1);
    //updated.splice(index, 1);
    onDelete([...deleteRows, ...deletedRow]);
    onChange(updated)
  };
  const handleLotAssort = (row) => {

    if (row[RowsField.lotNo] != "" && row[RowsField.assortCode] != "" && row[RowsField.clvDate] != null && row[RowsField.weight] != 0)
      onLotAllotChange(row)
    else {
      if (!toast.isActive('toats_chkllotdetail')) {
        toast.error("Enter Lot Data", {
          "position": "top-center",
          "className": "toast-error",
          toastId: "toats_chkllotdetail",
        })
      }
    }

  }
  const handleKeyDown = (e, rowIndex, colIndex) => {
    const isLastCell = rowIndex === rows.length - 1 && colIndex === columns.length - 1;
    if (e.key === 'Tab' && !e.shiftKey && isLastCell) {
      // Delay to let the focus move before adding row
      setTimeout(() => {
        addRow();
      }, 10);
    }
  };

  return (
    <div className="bg-white font-normal shadow-md rounded-lg p-1 mb-10">
      <Button
        onPress={addRow}
        size="sm"
        startContent={<FontAwesomeIcon className='text-md' icon={faPlus}></FontAwesomeIcon>}
        className=" bg-blue-800  h-7 hover:bg-green-700 text-white  rounded"
      >
        ADD ROW
      </Button>
      <div className="overflow-x-auto w-full max-h-[500px] relative">
        <table className="min-w-full text-center text-xs table-auto border-1">
          <thead className="sticky top-0 bg-slate-600   text-white z-10">
            <tr className="text-center">
              <th className="p-2 text-xs uppercase font-normal">Action</th>
              {selColumn.map((col) => (
                <th key={col.name} className="text-xs uppercase font-normal p-2">{col.label}</th>
              ))}

            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={row.id} className="odd:bg-gray-50 even:bg-white">
                <td className="p-2 cursor-pointer">
                  <FontAwesomeIcon icon={faTrashAlt}
                    onClick={() => removeRow(rowIndex)}
                    className="bg-red-500 hover:bg-red-600 text-white px-1 py-1 rounded"
                  />
                </td>
                {selColumn.map((col, colIndex) => (
                  <td key={col.name} className="p-2">
                    {col.type === 'select' ? (<Autocomplete
                      size="sm"
                      name={col.name}
                      label={""}
                      eventResizeFeature={true}
                      selectionMode="single"
                      showScrollIndicators={true}
                      labelPlacement={"outside"}
                      placeholder={"select"}
                      isRequired={col.required}
                      menuTrigger={"input"}
                      ref={el => {
                        if (colIndex === 0) {
                          inputRefs.current[`${row.id}-${col.name}`] = el;
                        }
                      }}
                      // isLoading={isPendingData}
                      className="w-32"
                      classNames={{
                        label: "text-xs text-black font-bold",
                      }}
                      isClearable={false}
                      isVirtualized

                      defaultItems={
                        col.data ? col.data : []
                      }
                      variant='flat'
                      color='warning'
                      onSelectionChange={(e) =>
                        handleChange(rowIndex, col.name, e)
                      }
                      selectedKey={row[col.name]}
                    >
                      {(list) => (
                        <AutocompleteItem
                          key={list[col.keyfield]}
                        >
                          {list[col.valuefield]}
                        </AutocompleteItem>
                      )}
                    </Autocomplete>) :
                      col.type == "date" ? (<LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label={col.label}
                          views={["day", "month", "year"]}
                          format="DD/MM/YYYY"
                          value={
                            row[col.name]
                              ? dayjs(row[col.name])
                              : row[col.name]
                          }
                          onChange={(newValue) => {
                            handleDateChange(rowIndex, col.name, newValue)
                          }}
                          //isRequired={item.required}
                          className="w-36"
                          slotProps={{
                            textField: {
                              sx: {
                                '& .MuiInputBase-root': {
                                  height: 30,         // Adjust height here
                                  fontSize: '0.875rem', // Optional: smaller font
                                },
                                '& .MuiInputLabel-root': {
                                  fontSize: '0.875rem',
                                },
                                '& input': {
                                  padding: '8px 10px',
                                }
                              },
                              size: "small", required: false
                            },
                          }}
                        />
                      </LocalizationProvider>) :
                        col.type === 'button' ? (
                          <Button radius='sm' startContent={<FontAwesomeIcon icon={faFileEdit}></FontAwesomeIcon>}
                            className='h-6 bg-emerald-700 text-white' size="sm" onPress={() => handleLotAssort(row)} >Lot Details</Button>) :
                          (<input
                            name={col.name}
                            className="w-20 border border-slate-700 rounded px-2 py-1"
                            type={col.type || 'text'}
                            value={row[col.name]}
                            required={col.required}
                            readOnly={(['valueRs', 'valueD'].includes(col.name)) ? true :
                              col.readonly || false}
                            disabled={(col.name == 'lotNo' && row['detailId'] > 0) ? true : false}
                            onChange={(e) =>
                              handleChange(rowIndex, col.name, col.type === 'number' ? parseFloat(e.target.value) : e.target.value)
                            }
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, colIndex)}
                            onFocus={(e) => e.target.select()}
                            onBlur={(e) => handleBlur(rowIndex, col.name, e.target.value)}
                            ref={el => {
                              if (colIndex === 0) {
                                inputRefs.current[`${row.id}-${col.name}`] = el;
                              }
                            }}
                          />)
                    }
                  </td>
                ))}

              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default DynamicTable;
